import { GlideFunctionalRenderer } from "common/components/uis";
import { asString, loadedDefinedMap, loadedDefinedMapWithDefault } from "common/components/component-helpers";
import { TextSize } from "common/generator/components/text-types";
import AvatarOverlayView from "../ui/views/avatar-overlay/avatar-overlay-view";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

export const AvatarOverlayMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[imagePV, captionPV, textSizePV]] = useForceValueProducers(getValueProducers, force, ctx);
    const text = loadedDefinedMap(captionPV, asString);
    const image = loadedDefinedMap(imagePV, asString);
    const textSize = loadedDefinedMapWithDefault(textSizePV, TextSize.Medium, asString) as TextSize;

    if (text === undefined && image === undefined) return null;

    return <AvatarOverlayView image={image} text={text} textSize={textSize} appID={env.appEnvironment.appID} />;
};
